import React from 'react'
import { Link } from 'react-router-dom'
import appStoreBtn from '../../assets/btn-app-store.svg'
import ggPlayBtn from '../../assets/btn-gg-play.svg'
import { appURL } from '../../constants'
import GeneralNotifModal from '../GeneralModal/generalNotifModal'
import styles from './TopupGuideline.module.css'

const TopupGuideline = ({ children, open, dismiss = () => { } }) => {
  return <GeneralNotifModal open={open} contentClass={styles.topUpGuidelineModal}>
    <div className={styles.header}>
      {children}
    </div>
    <div className={styles.wrapper}>
      <div className={styles.title}>
        How to top-up Diamond?
      </div>
      <div className={styles.subtitle}>
        You can top up diamond via Genflix App. Please download Genflix app on App Store or Google Play store
      </div>
      <div className={styles.footer}>
        <Link to={appURL.APP_STORE} target='_blank'>
          <img alt='app-store-button' src={appStoreBtn} />
        </Link>
        <Link to={appURL.GOOGLE_PLAY} target='_blank'>
          <img alt='google-play-button' src={ggPlayBtn} />
        </Link>
      </div>
      <div className={styles.action} onClick={dismiss}>
        <span>Got it</span>
      </div>
    </div>
  </GeneralNotifModal>
}

export default TopupGuideline;